import React from 'react';
import { createClient } from '@supabase/supabase-js';
import * as FiIcons from 'react-icons/fi';

export const TABLES = {
  USERS: 'users_1740126000000',
  ITEMS: 'items_1740126000000',
  LOGS: 'drop_logs_1740126000000',
  CHARACTERS: 'characters_1740130000000',
  PILOT_MASTERS: 'pilot_masters_1740250000000'
};

const SUPABASE_URL = 'https://soaxjsjkwtrnnewfjjyx.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNvYXhqc2prd3Rybm5ld2Zqanl4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEzNjQwMzYsImV4cCI6MjA4Njk0MDAzNn0.M6MMN_LPtBKZktXoZsuBTH1ItLg2Z8c-OQUSQXVSeo8';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export const checkConnection = async () => {
  try {
    const { error } = await supabase.from(TABLES.USERS).select('count', { count: 'exact', head: true });
    return !error;
  } catch (e) {
    return false;
  }
};

export const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  try {
    IconComponent = icon || (name && FiIcons[`Fi${name}`]);
  } catch (e) {
    IconComponent = null;
  }
  return IconComponent 
    ? React.createElement(IconComponent, props) 
    : React.createElement(FiIcons.FiAlertTriangle, props);
};